import React from 'react'
import { InputText } from '../../../Application/components/InputText'

export const ProfileDescription = () => {
  return (
    <InputText id="description" label="Description" multiline rows={4} inputProps={{ style: { fontWeight: 400 } }} />
  )
}
